module.exports = __webpack_public_path__ + "static/img/background.afa1c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.png
// module id = cf+J
// module chunks = 1